<template>
  <div class="row">
    <div class="col-sm-8 p-0">
      <pdfViewer :file="idFileShow" :files="files" style="height: calc(-20px + 100vh);" />
    </div>
    <div class="col-sm-4">
      <div class="form-group text-center">
        <div v-if="archivosClean.firmaonile" class="form-check">
          <input class="form-check-input" type="checkbox" v-model="Docfirmar" :value="idFileShow" :id="'checkfirmar'">
          <label :class="'form-check-label' + (archivosClean.firmaonile ? ' text-success' : '')" for="checkfirmar">
            Seleccionar para
            firmar</label>
        </div>
        <button type="button" class="btn btn-success btn-sm my-1" :disabled="verificando" @click.stop="verificarFirma">
          <span class="glyphicon glyphicon-eye-open"></span> Verificar firma digtal
        </button>
      </div>
      <template v-if="Resulloadin">
        <small class="text-warning text-center">Verificando firma digital...</small>
      </template>
      <template v-else-if="isVerified">
        <small v-if="resulFirma.listSignatures.length != 0" class="mt-2">
          <h3 :class="firmaColorClass" class="text-center">
            <span :class="isFirmaIndeterminada ? 'glyphicon glyphicon-warning-sign' : (isFirmaValida ? 'glyphicon glyphicon-ok' : 'glyphicon glyphicon-remove')"></span> {{ resulFirma.result }}
          </h3>
          <div class="form-group row p-0 mb-0">
            <label for="" class="col-sm-4 text-info mb-0 px-0">Fecha de validación:</label>
            <div class="col-sm-8" :class="firmaColorClass">{{ resulFirma.validationDate }}</div>
          </div>
          <div class="form-group row p-0 mb-0">
            <label for="" class="col-sm-4 text-info mb-0 px-0">Documento validado:</label>
            <div class="col-sm-8" :class="firmaColorClass">{{ resulFirma.file }}</div>
          </div>
          <div class="form-group row p-0 mb-0">
            <label for="" class="col-sm-3 text-info mb-0 px-0">Integridad:</label>
            <div class="col-sm-9 px-0" :class="(resulFirma.result == 'RESULTADO INDETERMINADO')||(resulFirma.result == 'RESULTADO VÁLIDO') ? 'text-success' : 'text-danger'">{{ resulFirma.integrity }}</div>
          </div>
          <div class="form-group row p-0 mb-0">
            <label for="" class="col-sm-3 text-info mb-0 px-0">Observaciones:</label>
            <div class="col-sm-9 px-0" :class="firmaColorClass">
              <div v-for="(obs, index) in resulFirma.observations" :key="index">
                {{ obs }}
              </div>
            </div>
          </div>
          <p class="text-warning">Firmantes</p>
          <ul class="list-group mr-2">
            <li v-for="(item, index) in resulFirma.listSignatures" :key="index"
              class="list-group-item d-flex justify-content-between align-items-center p-2 mb-2"
              style="border: 1px solid #495057; border-radius: 4px; background-color: #2b3035;">
              <div class="text-truncate pr-2">
                <span :class="getSignatureClass(item)">({{ index + 1 }})</span>
                <span class="ml-1" style="font-size: 0.9em;" :class="getSignatureClass(item)">{{ item.signer }}</span>
              </div>
              <div class="d-flex align-items-center flex-shrink-0">
                <button type="button" class="btn btn-outline-info btn-xs mr-2" @click.stop="showSignatureDetails(item)" style="padding: 2px 5px; font-size: 0.8em;">
                  <span class="glyphicon glyphicon-info-sign"></span> Detalle
                </button>
                <span :class="getSignatureIconClass(item)"></span>
              </div>
            </li>
          </ul>
        </small>
        <small v-else>
          <h5 class="text-danger text-center">
            <span class="glyphicon glyphicon-remove"></span> Documento no cuenta con firma digital
          </h5>
        </small>
      </template>

      <!-- aqui mostramos todos los documentos adjuntos al tramite por id documento -->
      <ResumenF ref="test" :archivos="archivos" :referentes="archivosreferentes" :doc-firmar="Docfirmar"
        @show="DatosaVisualizar" />

      <!-- Modal para detalles de la firma -->
      <div class="modal fade" id="modalDetalleFirma" tabindex="-1" role="dialog" aria-labelledby="modalDetalleFirmaLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document">
          <div class="modal-content" style="background-color: #212529; color: #f8f9fa; border: 1px solid #495057;">
            <div class="modal-header py-2" style="border-bottom: 1px solid #495057; background-color: #343a40;">
              <h5 class="modal-title" id="modalDetalleFirmaLabel">
                <span :class="selectedSignature ? getSignatureIconClass(selectedSignature) : ''" class="mr-2"></span>
                Detalles de la Firma
              </h5>
              <button type="button" class="close text-white" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body" v-if="selectedSignature">
              <div class="row">
                <!-- Columna Izquierda: Información de la firma -->
                <div class="col-md-6">
                  <div class="info-section-title">Información de la firma</div>
                  <div class="info-row">
                    <span class="info-label">Estado de la firma</span>
                    <span class="info-value font-weight-bold" :class="getSignatureClass(selectedSignature)">
                      {{ getSignatureStatus(selectedSignature) }}
                    </span>
                  </div>
                  <div class="info-row">
                    <span class="info-label">Formato y nivel</span>
                    <span class="info-value">{{ selectedSignature.format || '---------' }}</span>
                  </div>
                  <div class="info-row">
                    <span class="info-label">Fecha y hora</span>
                    <span class="info-value">{{ selectedSignature.date || '---------' }}</span>
                  </div>
                  <div class="info-row">
                    <span class="info-label">Algoritmo de firma</span>
                    <span class="info-value">{{ selectedSignature.signatureAlgorithm || '---------' }}</span>
                  </div>
                  <div class="info-row">
                    <span class="info-label">Validez del certificado</span>
                    <span class="info-value">{{ selectedSignature.notAfter || '---------' }}</span>
                  </div>
                  <div class="info-row-full">
                    <span class="info-label">Generada por</span>
                    <span class="info-value">{{ selectedSignature.signer || '---------' }}</span>
                  </div>
                </div>

                <!-- Columna Derecha: Información de confianza -->
                <div class="col-md-6">
                  <div class="info-section-title">Información de confianza</div>
                  <div class="info-row">
                    <span class="info-label">Raíz en TSL</span>
                    <span class="info-value">{{ selectedSignature.rootInTsl ? 'Sí' : 'No' }}</span>
                  </div>
                  <div class="info-row">
                    <span class="info-label">Raíz de TSA en TSL</span>
                    <span class="info-value">{{ selectedSignature.rootTsaInTsl ? 'Sí' : 'No' }}</span>
                  </div>
                  <div class="info-row">
                    <span class="info-label">Fecha y hora (TSA)</span>
                    <span class="info-value">{{ selectedSignature.tsaDate || '---------' }}</span>
                  </div>
                  <div class="info-row-full">
                    <span class="info-label">Notas TSA</span>
                    <span class="info-value">{{ selectedSignature.tsaNotes || '---------' }}</span>
                  </div>
                </div>
              </div>

              <hr style="border-top: 1px solid #495057;" />

              <div class="row">
                <!-- Columna Izquierda: Indicaciones -->
                <div class="col-md-6">
                  <div class="info-section-title">Indicaciones del proceso</div>
                  <div v-if="selectedSignature.notes && selectedSignature.notes.length" class="mb-2">
                    <div v-for="(note, nIdx) in selectedSignature.notes" :key="'modal-note-'+nIdx" class="text-white-50" style="font-size: 0.85em; margin-bottom: 2px;">
                      {{ note }}
                    </div>
                  </div>
                  <div v-if="selectedSignature.warnings && selectedSignature.warnings.length" class="mb-2">
                    <div v-for="(warn, wIdx) in selectedSignature.warnings" :key="'modal-warn-'+wIdx" class="text-warning" style="font-size: 0.85em; margin-bottom: 2px;">
                      ⚠ {{ warn }}
                    </div>
                  </div>
                  <div v-if="selectedSignature.errors && selectedSignature.errors.length && selectedSignature.status !== 'VÁLIDO'" class="mb-2">
                    <div v-for="(err, eIdx) in selectedSignature.errors" :key="'modal-err-'+eIdx"
                      :class="getSignatureStatus(selectedSignature) === 'INDETERMINADO' ? 'text-warning' : 'text-danger'"
                      style="font-size: 0.85em; margin-bottom: 2px;">
                      {{ getSignatureStatus(selectedSignature) === 'INDETERMINADO' ? '⚠' : '❌' }} {{ err }}
                    </div>
                  </div>
                  <div v-if="(!selectedSignature.notes || !selectedSignature.notes.length) && (!selectedSignature.warnings || !selectedSignature.warnings.length) && (!selectedSignature.errors || !selectedSignature.errors.length)" class="text-muted" style="font-size: 0.85em;">
                    Sin indicaciones
                  </div>
                </div>

                <!-- Columna Derecha: Información del certificado -->
                <div class="col-md-6">
                  <div class="info-section-title">Información del certificado</div>
                  <div class="info-row">
                    <span class="info-label">Número de serie</span>
                    <span class="info-value" style="font-size: 0.85em;">{{ selectedSignature.serial || '---------' }}</span>
                  </div>
                  <div class="info-row">
                    <span class="info-label">Validez desde</span>
                    <span class="info-value">{{ selectedSignature.notBeFore || '---------' }}</span>
                  </div>
                  <div class="info-row">
                    <span class="info-label">Validez hasta</span>
                    <span class="info-value">{{ selectedSignature.notAfter || '---------' }}</span>
                  </div>
                  <div class="info-row-full">
                    <span class="info-label">Ruta de certificación</span>
                    <span class="info-value" style="font-size: 0.85em; line-height: 1.2;">
                      <div v-for="(node, cIdx) in selectedSignature.chain" :key="'modal-chain-'+cIdx" :style="{ paddingLeft: (cIdx * 8) + 'px' }">
                        {{ cIdx > 0 ? '↳ ' : '' }}{{ node }}
                      </div>
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer" style="border-top: 1px solid #495057; background-color: #343a40;">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">Cerrar</button>
            </div>
          </div>
        </div>
      </div>

    </div>

  </div>
</template>

<script>
// import VuePdfEmbed from 'vue-pdf-embed/dist/vue2-pdf-embed'
import axios from '@/js/plugins/client'
import ResumenF from '../../buscar-documento/ResumenFoliosVisor.vue'
import pdfViewer from './pdfViewer.vue'

export default {
  name: 'SgdVisorpdf',
  components: {
    pdfViewer,
    ResumenF
  },
  props: {
    archivos: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      isLoading: true,
      isVerified: false,
      page: null,
      pageCount: 1,
      scale: 1.8,
      width: 500,
      height: 400,
      textLayer: true,
      showAllPages: true,
      Resulloadin: false,
      verificando: false,
      urlnuevo: null,
      idFileNuevo: null,
      idFileShow: Number(this.archivos.id),
      archivosreferentes: {
        archivosdoc: []
      },
      resulFirma: {
        detailedReport: null,
        errorMessage: null,
        file: null,
        generatedBy: null,
        integrity: null,
        listSignatures: [],
        observations: [],
        result: null,
        signatures: null,
        trustedSignatures: true,
        validSignatures: null,
        validationDate: null
      },
      Docfirmar: [],
      selectedSignature: null
    }
  },
  computed: {
    isFirmaValida() {
      return this.resulFirma && (this.resulFirma.result === 'RESULTADO VÁLIDO' || this.resulFirma.result === 'RESULTADO INDETERMINADO')
    },
    isFirmaIndeterminada() {
      return this.resulFirma && this.resulFirma.result === 'RESULTADO INDETERMINADO'
    },
    firmaColorClass() {
      if (this.isFirmaIndeterminada) {
        return 'text-warning'
      }
      return this.isFirmaValida ? 'text-success' : 'text-danger'
    },
    pdfSource() {
      var url = 'tramite/documento/print/archivo/' + this.idFileShow;
      return '/' + url
    },
    idDocumento() { return this.archivos.id_documento },
    idFile() { return this.archivos.id },
    files() {
      return this.archivosreferentes.archivosdoc.reduce((a, archivo) => { return a.concat(archivo.docu_archivo) }, [])
    },
    // Creamos una versión "limpia" de la prop
    archivosClean() {
      const clean = {};

      // Recorremos las llaves del objeto archivos
      Object.keys(this.archivos).forEach(key => {
        const value = this.archivos[key];

        if (value === "undefined") {
          // Si es el texto "undefined", lo convertimos en 0 o null
          clean[key] = 0;
        } else if (value === "true") {
          // Si es el texto "true", lo convertimos a booleano real
          clean[key] = true;
        } else if (!isNaN(value) && typeof value === 'string') {
          // Si es un número en texto ("2532753"), lo convertimos a número real
          clean[key] = Number(value);
        } else {
          // De lo contrario, dejamos el valor original
          clean[key] = value;
        }
      });

      return clean;
    }
  },
  watch: {
    showAllPages() {
      this.page = this.showAllPages ? null : 1
    },
    Docfirmar: {
      handler(newValue) {
        this.syncDocfirmar(newValue)
      },
      deep: true
    }
  },
  mounted() {
    this.initVisor(this.archivos);
    this.verificarFirma()
    this.mostrarresultados(this.archivos.id_documento, true)
    this.syncDocfirmar(this.Docfirmar)
  },
  methods: {
    syncDocfirmar(ids = []) {
      if (typeof window === 'undefined') {
        return
      }
      const selectedIds = Array.isArray(ids) ? ids.map(id => Number(id)) : []
      const selectedFiles = this.files
        .filter(file => selectedIds.includes(Number(file.id)))
        .map(file => ({
          id: Number(file.id),
          id_documento: file.id_documento,
          file_tipo: file.file_tipo,
          file_name: file.file_name,
          tipo: 1
        }))

      window.dispatchEvent(new CustomEvent('sgd-docfirmar-sync', {
        detail: {
          ids: selectedIds,
          files: selectedFiles
        }
      }))

      const syncPayload = JSON.stringify({
        ids: selectedIds,
        files: selectedFiles,
        updated_at: Date.now()
      })
      window.localStorage.setItem('sgd-docfirmar-sync', syncPayload)
    },

    mostrarresultados(iddoc, visor = false)//Actual tramite
    {
      this.visorpdf = visor
      var url = '/archivoscargados/' + iddoc;

      axios.get(url).then(res => {
        // console.log(res.data)
        this.archivosreferentes = res.data
        // eslint-disable-next-line no-undef
        $('#verarchivostotal').modal();
      })
    },
    cerrar() {
      this.isVerified = false,
        this.Resulloadin = false
    },
    initVisor() {
      // eslint-disable-next-line no-undef
      $('#mdvisor').modal({
        backdrop: 'static',
        keyboard: false
      })
    },
    handleDocumentRender() {
      this.isLoading = false
      this.pageCount = this.$refs.pdfRef.pageCount
    },
    handlePasswordRequest(callback, retry) {
      callback(prompt(retry ? 'Enter password again' : 'Enter password'))
    },
    verificarFirma() {
      if (!this.verificando) {
        this.Resulloadin = true;
        this.isVerified = false;
        this.verificando = true;
        const parameter = {
          //ruta   : this.pdfSource,
          idfile: this.idFileShow,
          iddoc: this.idDocumento,
        }
        var url = '/verificafirma';
        axios.get(url, {
          params: parameter
        }).then(resp => {
          this.resulFirma = resp.data
          this.Resulloadin = false;
          this.isVerified = true;
          this.verificando = false;
        }).catch(error => {
          console.error(error)
          this.Resulloadin = false;
        })
      }
    },
    DatosaVisualizar(DocuArchivos) {
      this.idFileShow = DocuArchivos.id;
      this.resulFirma = {}
      this.verificarFirma();
      // console.log(DocuArchivos);

    },
    getSignatureStatus(item) {
      if (!item) return ''
      if (item.status === 'INDETERMINADO' || item.status === 'INDETERMINATE') {
        return 'INDETERMINADO'
      }
      if (item.indications && item.indications.includes('INDETERMINATE')) {
        return 'INDETERMINADO'
      }
      return item.status
    },
    getSignatureClass(item) {
      if (!item) return 'text-danger'
      const status = this.getSignatureStatus(item)
      if (status === 'VÁLIDO' || status === 'VALID') {
        return 'text-success'
      }
      if (status === 'INDETERMINADO' || status === 'INDETERMINATE') {
        return 'text-warning'
      }
      return 'text-danger'
    },
    showSignatureDetails(item) {
      this.selectedSignature = item
      // eslint-disable-next-line no-undef
      $('#modalDetalleFirma').modal('show')
    },
    getSignatureIconClass(item) {
      const status = this.getSignatureStatus(item)
      if (status === 'VÁLIDO' || status === 'VALID') {
        return 'glyphicon glyphicon-ok text-success'
      }
      if (status === 'INDETERMINADO' || status === 'INDETERMINATE') {
        return 'glyphicon glyphicon-warning-sign text-warning'
      }
      return 'glyphicon glyphicon-remove text-danger'
    }
  }
}
</script>

<style scoped>
.vue-pdf-embed>div {
  margin-bottom: 8px;
  box-shadow: 0 2px 8px 4px rgba(0, 0, 0, 0.1);
}

.app-header {
  padding: 16px;
  box-shadow: 0 2px 8px 4px rgba(0, 0, 0, 0.1);
  background-color: #555;
  color: #ddd;
}

.app-content {
  padding: 24px 16px;
}

.right {
  float: right;
}

.modal-lg {
  width: 80%;
}

.list-group-item {
  border: 1px solid #636669;
  background-color: #ffffff08;
}

.signature-accordion-container {
  margin-top: 10px;
}

.signature-accordion {
  border: 1px solid #495057;
  border-radius: 4px;
  margin-bottom: 8px;
  background-color: #2b3035;
  color: #f8f9fa;
  overflow: hidden;
}

.signature-header {
  background-color: #343a40;
  border-bottom: 1px solid #495057;
  transition: background-color 0.2s ease;
  user-select: none;
}

.signature-header:hover {
  background-color: #3e444b;
}

.signature-body {
  padding: 12px;
  font-size: 0.85em;
  background-color: #212529;
}

.info-section-title {
  font-weight: bold;
  border-bottom: 1px solid #495057;
  margin-top: 10px;
  margin-bottom: 6px;
  padding-bottom: 2px;
  color: #17a2b8;
}

.info-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 4px 0;
  border-bottom: 1px dashed #343a40;
}

.info-row-full {
  display: flex;
  flex-direction: column;
  padding: 5px 0;
  border-bottom: 1px dashed #343a40;
}

.info-label {
  color: #adb5bd;
  font-weight: 500;
}

.info-value {
  text-align: right;
  word-break: break-all;
  color: #f8f9fa;
}

.info-row-full .info-value {
  text-align: left;
  margin-top: 2px;
  word-break: break-word;
}

.footer_div {
  position: absolute;
  bottom: 10px;
  right: 10px;
  width: 90%;
}
</style>
